import { createReactElement, UpdatableReactElement } from 'shared/utils/react.utils'
import { BaseModalController, IModal, ModalContext } from '../Modal'
import { ActionModal } from 'Components/modal/ActionModal/ActionModal'
import { AttributeDefinitionType } from 'Types/Tasks.types'

export type ActionModalMetaData = unknown

export class ActionModalController
    extends BaseModalController<ActionModalMetaData>
    implements IModal
{
    static Id = 'action-modal' as const
    constructor(modalContext: ModalContext) {
        super(modalContext, ActionModalController.Id)
    }

    createElement(): UpdatableReactElement {
        return createReactElement(ActionModal, {
            getVisibility: this.getVisibility.bind(this),
            onCancel: () => {
                this.onActionModalClose()
            },
            content: 'Do you want to edit the response?',
            onConfirm: () => {
                this.onActionModalClose('submit')
            },
            closable: false,
        })
    }

    private onActionModalClose = (action: 'submit' | 'dismiss' = 'dismiss') => {
        // Right now, we only use this modal for confirmation on Editing the Response in Reviewer. If required for other uses, pass parameters along with the mode.
        if (action === 'submit') {
            this.modalContext.task.setReadOnly(false)
            this.modalContext.studio.workbench.enqueueUiUpdate(() => {
                this.modalContext.task.actionManager?.removeActions([
                    'Skip',
                    'FinishReview',
                    'FinishQC',
                    'Exit',
                    'SaveForLater',
                ])
                this.modalContext.task.addMakerActions()
            })
            this.modalContext.task.updateAttributesUI()
        }
        this.setVisibility(false)
        this.modalContext.task.ui?.updater.forceUpdate()
        const extraInfoGroups =
            this.modalContext.task.attributeManager?.getAttributeGroupsByDefinitionType(
                AttributeDefinitionType.EXTRA_INFO
            )
        const qcGroups =
            this.modalContext.task.attributeManager?.getAttributeGroupsByDefinitionType(
                AttributeDefinitionType.QUALITY_EVALUATION
            )
        const turnAttributeGroups =
            this.modalContext.task.attributeManager?.getAttributeGroupsByDefinitionType(
                AttributeDefinitionType.TURN_EVALUATION
            )
        extraInfoGroups?.forEach(group => {
            group.render()
        })
        qcGroups?.forEach(group => {
            group.render()
        })
        turnAttributeGroups?.forEach(group => {
            group.render()
        })
    }
}
